export default {
	color: {
		headingGrey: '#58585a',
		red: '#a91e21',
		purple: '#1a0b46',
		grey: '#707070',
	},
	fonts: {
		heading: 'Barlow Condensed, sans-serif',
		body: 'Roboto Condensed, sans-serif',
	},
	gutterMobile: '2rem',
	gutter: '4rem',
	gutterWide: '8rem',
	gutterXWide: '12rem',
};
